import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { CONTENT_PREFERENCE_CRITERIA } from 'bdvp-advanced-search/src/utils/constants';

import { useSearchGames } from '../hooks/store';
import {
    useTeamId,
    useIsClubPage,
} from '../hooks/config';

import Component from '../components/GamesRow';

const LIMIT = 36;

const GamesRow = forwardRef(({
    skip,
    ssr,
    properties,
    rank,
    className,
}, ref) => {

    let {
        title,
        query,
        queryClubFilter,
        queryDate,
    } = properties;
    const teamId = useTeamId();
    const isClubPage = useIsClubPage();
    if (isClubPage && queryClubFilter) {

        query = `${queryClubFilter} == [${teamId}] AND ${query}`;

    }
    if (queryDate) {

        query = `${queryDate} AND ${query}`;

    }

    const {
        loading,
        loadingMore,
        data,
        fetchMoreData,
        hasMore,
    } = useSearchGames(query, {
        ssr,
        limit: LIMIT,
        skip,
        contentPreference: CONTENT_PREFERENCE_CRITERIA.mixed,
    });

    const list = data?.search?.plays ?? [];

    return (
        <Component
            ref={ref}
            className={className}
            title={title}
            list={list}
            hasMore={hasMore}
            fetchMoreData={fetchMoreData}
            isLoading={skip || loading}
            isLoadingMore={loadingMore}
            limit={LIMIT}
            rank={rank}
        />
    );

});

GamesRow.propTypes = {
    rank: PropTypes.number.isRequired,
    skip: PropTypes.bool,
    ssr: PropTypes.bool,
    properties: PropTypes.object,
};

GamesRow.defaultProps = {
    skip: false,
    ssr: true,
    properties: {},
};

export default GamesRow;
